import { http, isHttpError } from '@/http';
import { RedeemPromoCodeResponse } from '@/entities/payment';

export const redeemPromoCode = (onboardingUlid: string, code: string) =>
  http.post<RedeemPromoCodeResponse>('v1/payments/promo-code', {
    onboarding_ulid: onboardingUlid,
    code,
  });

export const mapPromoError = (error: unknown): string => {
  const code = isHttpError(error)
    ? (error.response?.data as { code?: string } | undefined)?.code
    : undefined;
  switch (code) {
    case 'PROMO_CODE_NOT_FOUND':
      return 'El código no existe.';
    case 'PROMO_CODE_ALREADY_USED':
      return 'Este código ya fue utilizado.';
    case 'VALIDATION_ERROR':
      return 'Ingresa un código válido.';
    default:
      return 'No se pudo aplicar el código. Intenta de nuevo.';
  }
};
